"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var idm_crosscutting_concepts_frontend_1 = require("@synisys/idm-crosscutting-concepts-frontend");
var RecipientComboModel = /** @class */ (function () {
    function RecipientComboModel(email, name, languageId) {
        this.email = email;
        this.name = name;
        if (name instanceof idm_crosscutting_concepts_frontend_1.MultilingualString && languageId) {
            this.name = name.getValue(languageId);
        }
    }
    return RecipientComboModel;
}());
exports.RecipientComboModel = RecipientComboModel;
//# sourceMappingURL=recipient-combo.model.js.map